import type { FieldTree } from '@angular/forms/signals';
import { readonly } from '@angular/forms/signals';

import type { ScrollEffectSettings } from '@sites/entity-core';

// Thunk is mandatory: see `createBorderAccessors`.
export const createScrollEffectAccessors = (getField: () => FieldTree<ScrollEffectSettings>) => ({
    get scrollEffect() {
        return getField();
    },
    setScrollEffect: (patch: Partial<Omit<ScrollEffectSettings, 'version'>>) => {
        getField()().value.update((current) => ({ ...current, ...patch }));
    },

    setScrollEffectEnabled: (value: boolean) => {
        getField().isEnabled().value.set(value);
    },
    setScrollEffectValue: (value: string) => {
        getField().value().value.set(value);
    },
});

export type ScrollEffectAccessors = ReturnType<typeof createScrollEffectAccessors>;

export const applyScrollEffectFieldRules = (scrollEffectPath: any): void => {
    readonly(scrollEffectPath.version);
};
